<hawk-record-navigation
  [breadcrumbLinkList]="[{ link: '/a/lager/uebersicht', description: 'Lager' }]"
  [root]="'warehouse'"
  [leafDescription]="'Erwartete Lieferungen'"
  class="app-page"
>
  <div slot="toolbar" class="flex flex-row gap-2 items-center">
    <a routerLink="/lager/erwartete-lieferungen/neu" class="bm-btn bm-btn-primary">
      <i class="fa fa-plus"></i>
      Neue Lieferung erfassen
    </a>
    <input
      type="text"
      class="bm-input"
      placeholder="Schnellfilter..."
      (input)="quickSearchChanged($event)"
    />
  </div>
  <div class="page-content px-4 pb-2">
    <ag-grid-angular
      class="ag-theme-quartz h-full"
      [rowData]="expectedDeliveries"
      [theme]="hawkTheme"
      [defaultColDef]="defaultColDef"
      [columnDefs]="colDefs"
      [rowClassRules]="rowClassRules"
      [pagination]="true"
      [rowSelection]="rowSelection"
      [autoSizeStrategy]="autoSizeStrategy"
      [paginationPageSize]="50"
      [localeText]="locale"
      [sideBar]="sideBarOptions"
      [paginationPageSizeSelector]="[25, 50, 100, 250]"
      (gridReady)="onGridReady($event)"
    />
  </div>
</hawk-record-navigation>
